import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Card from '../Card';

import styles from './_index.module.scss';

const TopicCard = ({ children, footer, isDraft = false, isExcluded = false, title }) => {
  return (
    <Card
      className={classNames(styles['topic-card'], {
        [styles['is-excluded']]: isExcluded,
      })}
      padding={'x-large'}
    >
      {title && (
        <div
          className={classNames(styles['card-title'], {
            [styles['draft-title']]: isDraft,
          })}
        >
          <ReactMarkdown>{title}</ReactMarkdown>
        </div>
      )}
      {<div className={styles['card-body']}>{children}</div>}
      {footer && <div className={styles['card-footer']}>{footer}</div>}
    </Card>
  );
};

TopicCard.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  isDraft: PropTypes.bool,
  isExcluded: PropTypes.bool,
  title: PropTypes.node,
};

export default TopicCard;
